import React from 'react';
import { AlarmClockIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { useLaunchCountdown } from '../../hooks/useLaunchCountdown';
const SEATS_TAKEN = 68;
function Unit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex w-[56px] flex-col items-center min-[380px]:w-[68px] sm:w-[86px]" data-id="element-267" data-mp="2blkw15rgiyso">
      <span className="font-display text-[40px] leading-none tabular-nums text-cocoa min-[380px]:text-5xl sm:text-6xl" data-id="element-268" data-mp="26mgm2cwpkx1a">{value}</span>
      <span className="mt-2 text-[10px] font-extrabold uppercase tracking-[0.16em] text-cocoa-dim sm:text-xs" data-id="element-269" data-mp="2z9b5r7lpbsdp">
        {label}
      </span>
    </div>;
}
export function Urgency() {
  const {
    hours,
    minutes,
    seconds,
    isExpired
  } = useLaunchCountdown();
  return <section className="w-full px-4 py-10 sm:px-5 sm:py-14" aria-labelledby="urgency-title" data-id="element-270" data-mp="2phf45mkepk4q">
      <Reveal className="mx-auto max-w-2xl" data-id="element-271" data-mp="3n0qat84v4nsn">
        <div className="rounded-3xl bg-terra-deep px-4 py-8 text-center shadow-[0_18px_44px_rgba(134,57,31,0.28)] sm:px-8 sm:py-10" data-id="element-272" data-mp="3i7nckmp54q64">
          <h2 id="urgency-title" className="mx-auto flex max-w-xl flex-col items-center justify-center gap-2 font-display text-[26px] leading-tight text-cream sm:flex-row sm:gap-2.5 sm:text-4xl" data-id="element-273" data-mp="k0qdz1tq85ss">
            {isExpired ? 'La promoción de lanzamiento finalizó' : <>
                <AlarmClockIcon className="h-6 w-6 flex-shrink-0 text-gold" aria-hidden="true" data-id="element-274" data-mp="f8p05bgwu70n" />
                <span data-id="element-275" data-mp="19fq6tjas954">Precio de lanzamiento — cierra en:</span>
              </>}
          </h2>

          {!isExpired && <div className="mt-6 flex justify-center" data-id="element-276" data-mp="69to3ir6q2pf">
              <div className="flex min-h-[96px] items-center justify-center gap-0.5 rounded-2xl bg-cream-card px-3 py-4 min-[380px]:gap-1 min-[380px]:px-4 sm:min-h-[120px] sm:gap-2 sm:px-7" role="timer" aria-live="off" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-277" data-mp="3oeeve2eubsft">
                <Unit value={hours} label="HS" data-id="element-278" data-mp="1qon9zhjwwx2x" />
                <span className="-mt-4 font-display text-3xl text-cocoa/25" aria-hidden="true" data-id="element-279" data-mp="1qnc9prpoe7gk">
                  :
                </span>
                <Unit value={minutes} label="MIN" data-id="element-280" data-mp="2zj7pa5ff3kb0" />
                <span className="-mt-4 font-display text-3xl text-cocoa/25" aria-hidden="true" data-id="element-281" data-mp="2ulfv14ravm3n">
                  :
                </span>
                <Unit value={seconds} label="SEG" data-id="element-282" data-mp="2qn044ps3ltky" />
              </div>
            </div>}

          <p className="mx-auto mt-6 max-w-md text-sm font-extrabold text-gold sm:text-base" data-id="element-283" data-mp="2lnnfq0lkweg9">
            {isExpired ? 'El precio volvió a su valor habitual. Podés acceder al Megapack Bolsos Crochet Pro cuando quieras.' : 'Después sube $6.000 ARS. No vuelve.'}
          </p>

          {!isExpired && <div className="mt-7 rounded-2xl bg-cocoa/35 px-4 py-5 sm:px-6" data-id="element-284" data-mp="39i6vzigmh5vd">
              <p className="text-center text-xs font-extrabold text-cream sm:text-sm" data-id="element-285" data-mp="34jm0fwcbfad9">
                <span className="mr-1.5 inline-block h-2 w-2 rounded-full bg-gold align-middle" aria-hidden="true" data-id="element-286" data-mp="5uwt20kzapj4" />
                Cupos al precio de lanzamiento — <span className="text-gold" data-id="element-287" data-mp="11ve5skrupzj">quedan pocos</span>
              </p>

              <div className="mt-3.5 h-3 w-full overflow-hidden rounded-full bg-cocoa/50" role="progressbar" aria-valuenow={SEATS_TAKEN} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos tomados al precio de lanzamiento" data-id="element-288" data-mp="8gnx0deoer4x">
                <div className="h-full rounded-full bg-gold" style={{
              width: `${SEATS_TAKEN}%`
            }} data-id="element-289" data-mp="ifn1djses0m4" />
              </div>

              <p className="mt-2 text-right text-[11px] font-extrabold text-gold sm:text-xs" data-id="element-290" data-mp="rcxihlrwqjyy">{SEATS_TAKEN}% tomados</p>
            </div>}
        </div>
      </Reveal>
    </section>;
}